export default "__VITE_ASSET__BfLwL28F__"